module.exports = __webpack_public_path__ + "static/media/Limitatin In Arbitration.c4d52071.jpg";